// Types
export type * from './types';

// Providers
export { StripeProvider, useStripeConfig, getStripe } from './StripeProvider';
export { BillingProvider, useBilling } from './BillingProvider';

// Hooks
export {
  useCanAccess,
  useSubscription,
  usePricing,
  useUpgradeCheck,
  useStripeCheckout,
} from './hooks';

// Legacy support (deprecated)
export { useCurrentPlan } from './useCurrentPlan';

// Utility functions
export const formatPrice = (amount: number | null, currency = 'usd') => {
  if (amount === null) return 'Free';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: 0,
  }).format(amount / 100);
};

export const formatInterval = (interval: string | null, intervalCount = 1) => {
  if (!interval) return '';

  const periods = {
    day: 'day',
    week: 'week',
    month: 'month',
    year: 'year',
  };

  const period = periods[interval as keyof typeof periods] || interval;
  return intervalCount === 1 ? period : `${intervalCount} ${period}s`;
};

export const getPlans = () => {
  // Deprecated - use usePricing() hook instead
  return [
    { id: 'free', name: 'Free' },
    { id: 'pro', name: 'Pro' },
  ];
};
